import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
declare const clevertap;

type SCREENING_CRITERIA = { criteria_id?: number, criteria_name: string, criteria_type: string, criteria_content: string, job_id: number, isactive?: boolean, created_on?: string, criteriacontent?: string, projectcriteriaid?: string, criteriapriority?: any };
type SCREENING_CRITERIA_SUGGESTION = { suggestion_id?: number, suggestion_name?: string, suggestion_content: string, created_on?: string, selected: boolean };

@Component({
    selector: 'app-evaluation-criteria',
    templateUrl: './evaluation-criteria.component.html',
    styleUrls: ['./evaluation-criteria.component.scss'],
    standalone: false
})
export class EvaluationCriteriaComponent implements OnInit {

  suggestedEvaluationCriteria: String[] = [];
  displayedEvaluationCriteria: String[] = [];
  selectedEvaluationCriteria: String[] = [];

  disableButton: boolean = false;
  showExploreCandidateSpinner: boolean = false;

  /**Hide static suggestions */
  hideSuggestions: boolean = false;

  /**Used to know any unsaved changes or not */
  unSavedChanges: boolean = false;

  projectnumber: string = '';
  showEvaluationCriteriaLoader: Boolean = false;

  cloneprojectnumber: string = '';

  @Input() tab: any;
  @Input() projectDetails: any;
  isProjectDetailsEvaluationCriteriaTab: Boolean = false;
  editMode: Boolean = false;

  SUGGESTED_CRITERIA: SCREENING_CRITERIA_SUGGESTION[] = [
    // { suggestion_content: 'Should have experience in leadership and managing team', selected: false },
    // { suggestion_content: '3 years experience working in Software development', selected: false },
    // { suggestion_content: 'Good to have experience in automation testing', selected: false },
    // { suggestion_content: 'Should have contact center experience as a customer service professional', selected: false },
  ];


  /**
   * Used for all criteria for AI Screening for job application
   */
  aiScreeningMasterForm = this.fb.group({
    criteria_0: this.fb.group({
      question: new UntypedFormControl(),
      id: new UntypedFormControl(null)
    })
  });


  removedCriteriaOnEdit = [];
  formChangeSubscription: any;
  successMessage: string = '';
  errorMessage: string = '';
  isAISourcingEnabled: boolean = false;
  changeButtonText:boolean = false;
  showNotifySpinner: boolean = false;
  storeProjectData: any | null = null;
  showSkeletonLoader: boolean = false;

  @ViewChild('editEvaluationCriteria') editEvaluationCriteria: TemplateRef<any>;
  @ViewChild('accessManagementModal') accessManagementModal: TemplateRef<any>;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private aiSourcingService: AiSourcingService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private localstorageservice: LocalStorageService,
    private modelService: NgbModal
  ) { }

  ngOnInit() {

    if (window.location.pathname?.split('/')[2] === 'project-details') {
      this.projectnumber = window.location.pathname?.split('/')[3];
    } else {
      const storeProjectData = JSON.parse(this.localstorageservice.getItem('parshedJD'));
      this.storeProjectData = storeProjectData;
      this.projectnumber = storeProjectData?.parshedJD?.projectnumber;
      this.cloneprojectnumber = storeProjectData?.cloneprojectnumber;
      if (this.cloneprojectnumber && this.cloneprojectnumber?.trim() && storeProjectData?.redirectSource !== 'edit' ) {
        this.getSuggestedEvaluationCriteria();
        this.getEvaluationCriteria(storeProjectData?.cloneprojectnumber);
      } else if(this.cloneprojectnumber && this.cloneprojectnumber?.trim() && storeProjectData?.redirectSource === 'edit' ) {
        const payload = {
          projectnumber: storeProjectData?.cloneprojectnumber,
          projectdetail: storeProjectData?.filterApplied
        };
        this.getCriteriaforEditProject(payload); 
      }
    }

    // this.projectnumber = window.location.pathname?.split('/')[3];
    if (this.tab) {
      this.isProjectDetailsEvaluationCriteriaTab = true;
      this.getEvaluationCriteria(this.projectnumber);
    } else {
      this.isProjectDetailsEvaluationCriteriaTab = false;
    }

    if (!this.cloneprojectnumber && !this.cloneprojectnumber?.trim()) {
      this.getSuggestedEvaluationCriteria();
    };
    this.isAISourcingEnabled = this.localstorageservice.getItem('autopilotslotaccess') == '1' ? true : false;


  }

  /**
   * Method to handle change criteria position with drop and drag
   * @param event
   */
  onDrop(event: CdkDragDrop<string[]>) {
    const keys = this.formLength();

    moveItemInArray(keys, event.previousIndex, event.currentIndex);

    const reorderedForm: any = {};
    keys.forEach(key => {
      reorderedForm[key] = this.aiScreeningMasterForm.get(key);
    });
    this.aiScreeningMasterForm = this.fb.group(reorderedForm);
  };

  /**
   * Method to handle edit evaluation criteria
   * @param type
   */
  enableEditMode(type: String) {
    if (type == 'edit') {
            if(this.tabClickAccess) {
            this.modelService.open(this.accessManagementModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false,
 });
 return
    }
      // this.getSuggestedEvaluationCriteria();
      this.editMode = true;


    /**
     * Edit evalution criteria
     */
         const createProjectParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
        }
        clevertap.event.push("Autopilot-Edit AI Evaluation Criteria",createProjectParams);
    } else {
      this.editMode = false;
    }
  };

/**
 * Method to get criteria for edit project
 * @param data 
 */
getCriteriaforEditProject(data: any) {
    this.showSkeletonLoader = true;
    this.aiSourcingService.editableProjectCriteria(data).subscribe((res: any) => {
      this.showSkeletonLoader = false;
      if(res && res.body && res.body.success) {
        this.populateScreeningData(res.body?.data?.existingSuggestedCriteria)
        const validCriteriaSuggestions = (res?.body?.data?.suggestedCriteria || []).map((item: any) => item).filter(Boolean);
        if (validCriteriaSuggestions.length) {
          this.SUGGESTED_CRITERIA = res.body.data?.suggestedCriteria?.map((item: any) => ({ suggestion_content: item, selected: false }));
        }
      } else {
        this.populateScreeningData([]);
        this.SUGGESTED_CRITERIA = [];
      }
    }, (err) => {
        this.populateScreeningData([]);
        this.SUGGESTED_CRITERIA = [];
        this.showSkeletonLoader = false;
    });
};

  /**
   * Get screening criteria
   */
  getEvaluationCriteria(projectnumber: string) {
    this.aiSourcingService.getProjectEvaluationCriteria(projectnumber).subscribe((res: any) => {
      if (res?.data) {
        this.populateScreeningData(res.data)
      }
    });
  }

  /**
   * Method to fetch project suggested evaluation criteria
   */
  getSuggestedEvaluationCriteria() {
    this.showEvaluationCriteriaLoader = true;
    this.aiSourcingService.getSuggestedEvaluationCriteria(this.projectnumber).subscribe((res: any) => {
      this.showEvaluationCriteriaLoader = false;
      if (res && res.status == 'success') {
        const validCriteriaSuggestions = (res?.data || []).map((item: any) => item).filter(Boolean);
        if (validCriteriaSuggestions.length) {
          this.SUGGESTED_CRITERIA = res.data?.map((item: any) => ({ suggestion_content: item, selected: false }));
        }
      } else {

      }
    })
  };


  /**
   * Populate data(criteria questions) into screnning form comping from backend
   * @param data
   */
  populateScreeningData(data: SCREENING_CRITERIA[]) {
    const sortedData = data.sort((a, b) => a.criteriapriority - b.criteriapriority);
    const formGroup = this.aiScreeningMasterForm;

    Object.keys(formGroup.controls).forEach(key => {
      if (key.startsWith('criteria_')) {
        formGroup.removeControl(key);
      }
    });

    sortedData.forEach((item, index) => {
      const controlName = `criteria_${index}`;

      const control = this.fb.group({
        question: [item.criteriacontent],
        id: [item.projectcriteriaid]
      });

      formGroup.addControl(controlName, control);
    });

    this.refreshCriteriaSuggestionsBasedOnFormState();
  }

  /**
   * Update criteria suggestions on the UI based on criteria form current state
   */
  refreshCriteriaSuggestionsBasedOnFormState() {
    const formGroup = this.aiScreeningMasterForm;
    const formGroupKeys = Object.keys(formGroup.controls);
    this.SUGGESTED_CRITERIA.forEach(suggestion => {
      const selectedSuggestionIdx = formGroupKeys.findIndex(key => {
        const FG = formGroup.controls[`${key}`] as UntypedFormGroup;
        return FG.getRawValue()?.question?.trim()?.toLowerCase() === suggestion.suggestion_content.trim().toLowerCase();
      });
      if (selectedSuggestionIdx !== -1) {
        suggestion.selected = true;
      } else {
        suggestion.selected = false;
      }
    });
    this.SUGGESTED_CRITERIA.sort(criteria => criteria.selected ? 1 : -1);
  }

  /**
   * Add new criteria form
   */
  addNewCriteria(data = null) {
    const formGroup = this.aiScreeningMasterForm;
    const uniqueId: string = GlobalService.generateUniqueId();
    if (data) {
      formGroup.addControl(`criteria_${uniqueId}`, new UntypedFormGroup({
        question: new UntypedFormControl(data?.criteria_content),
        id: new UntypedFormControl(data?.criteria_id)
      }));
    } else {
      formGroup.addControl(`criteria_${uniqueId}`, new UntypedFormGroup({
        question: new UntypedFormControl(),
        id: new UntypedFormControl(null)
      }));
    }

       /**
     * Add Evaluation Criteria
     */
         const evaluationParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Criteria": data?.criteria_content

        }
        clevertap.event.push("Autopilot-Add AI Evaluation Criteria",evaluationParams);
  }

  /**
   * Delete any criteria from ai screening
   * @param formGroup
   */
  deleteCriteria(formGroup) {
    const fg = this.aiScreeningMasterForm.controls[`${formGroup}`] as UntypedFormGroup;
    const deletedCriteriaId = fg.controls['id'].value;
    if (deletedCriteriaId) {
      this.removedCriteriaOnEdit.push({
        action: 'DELETE',
        criteria_id: deletedCriteriaId
      });
    }
    this.aiScreeningMasterForm.removeControl(formGroup);
    this.refreshCriteriaSuggestionsBasedOnFormState();

       /**
     * Delete Evaluation Criteria
     */
         const evaluationParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Criteria": deletedCriteriaId

        }
        clevertap.event.push("Autopilot-Delete AI Evaluation Criteria",evaluationParams);
  }

  /**
   * Method to open Edit Evaluation Criteria Model
   */
  openEditEvaluationCriteriaModel(){
    this.modelService.open(this.editEvaluationCriteria, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
   * Used to update or submit criteria questions
   */
  submitChanges() {
    const data = this.aiScreeningMasterForm.getRawValue();

    /** Get All the scrining criteria and store temporary*/
    const tempArr = [];
    let criteriaValidationCheck = false;
    for (let item in data) {
      tempArr.push(data[item]);
    }

    const payloadData: any = [];
    tempArr.forEach((item, i) => {

      if (this.cloneprojectnumber?.trim()) {
        item.id = item?.id ? null : null;
      };

      if (!item.question || !item.question.trim()) criteriaValidationCheck = true;
      if (item.id) {
        payloadData.push({
          // action: "UPDATE",
          projectcriteriaid: item.id,
          criteriacontent: item.question,
          criteriapriority: i + 1

        });
      } else {
        payloadData.push({
          // action: 'CREATE',
          projectcriteriaid: null,
          criteriacontent: item.question,
          criteriapriority: i + 1
        });
      }
    });

    // if (this.removedCriteriaOnEdit.length) {
    //   this.removedCriteriaOnEdit.forEach((item) => {
    //     payloadData.push({
    //       action: "DELETE",
    //       criteria_id: item.criteria_id
    //     })
    //   })
    // }

    if (criteriaValidationCheck) {
      this.errorMessage = 'Please Enter Valid Autopilot<sup><span>AI</span></sup> Evaluation Criteria';
      setTimeout(() => {
        this.errorMessage = '';
      }, 3000);
      this.dismiss();
      return;
    };

    this.disableButton = true;
    this.showExploreCandidateSpinner = true;


    if (this.storeProjectData && this.storeProjectData?.redirectSource === 'edit') {
      const payload = {
        criteria: payloadData,
        suggestedCriteria: this.SUGGESTED_CRITERIA.map((item) => item.suggestion_content),
        projectnumber: this.storeProjectData?.cloneprojectnumber,
        projectDetails: this.storeProjectData?.filterApplied
      };

      this.aiSourcingService.startProjectWithUpdatedDetails(payload).subscribe((res: any) => {
        this.showExploreCandidateSpinner = false;
        this.aiSourcingHandlerService.setDisplayPageEvent('insights');
        this.screeningFormReset();
        this.localstorageservice.clearItem('parshedJD');
        this.router.navigate(['/ai-sourcing/ai-sourcing-insights/' + this.storeProjectData?.cloneprojectnumber]);
        /**
         * Submit Evaluation Criteria
         */
        const evaluationParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Project Number": this.storeProjectData?.cloneprojectnumber
        }
        clevertap.event.push("Autopilot-Update AI sourcing details for sourcing candidates", evaluationParams);
      }, (err) => {
        this.showExploreCandidateSpinner = false;
        this.errorMessage = err?.error.message || 'Something went wrong. Please try again later';
        setTimeout(() => { this.errorMessage = ''; }, 3000);
      });

    } else {
      this.aiSourcingService.updateScreeningCriteria(payloadData, this.projectnumber).subscribe((res: any) => {
        this.showExploreCandidateSpinner = false;
        if (res && res.body && res.body.status == 'success') {
          this.disableButton = false;
          this.unSavedChanges = false;
          if (this.isProjectDetailsEvaluationCriteriaTab) {
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.getEvaluationCriteria(this.projectnumber);
            this.successMessage = 'Autopilot<sup><span>AI</span></sup> Evaluation Criteria successfully updated';
            this.editMode = false;
            this.dismiss();
            setTimeout(() => {
              this.successMessage = '';
            }, 3000);
            /**
             * Submit Evaluation Criteria for re-run
             */
            const evaluationParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Project Number": this.projectnumber

            }
            clevertap.event.push("Autopilot-Submit AI Evaluation Criteria to re-run sourcing", evaluationParams);
          } else {
            this.aiSourcingHandlerService.setDisplayPageEvent('insights');
            this.screeningFormReset();
            this.localstorageservice.clearItem('parshedJD');
            this.router.navigate(['/ai-sourcing/ai-sourcing-insights/' + this.projectnumber]);
            /**
            * Submit Evaluation Criteria
            */
            const evaluationParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Project Number": this.projectnumber

            }
            clevertap.event.push("Autopilot-Submit AI sourcing criteria for sourcing candidates", evaluationParams);
          }

        } else {
          this.errorMessage = res?.message || 'Something went wrong. Please try again later';
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
          this.screeningFormReset();
        };
      }, (err) => {
        this.errorMessage = err?.error.message || 'Something went wrong. Please try again later';
        this.showExploreCandidateSpinner = false;
        setTimeout(() => {
          this.errorMessage = '';
        }, 3000);
        // if(!this.isProjectDetailsEvaluationCriteriaTab){
        //   this.screeningFormReset();
        // }
      })
    }
  }

  /**
   * reset screening form to inital state
   */
  screeningFormReset() {
    this.aiScreeningMasterForm = this.fb.group({
      criteria_0: this.fb.group({
        question: new UntypedFormControl(),
        id: new UntypedFormControl(null)
      })
    });
    // this.getEvaluationCriteria();
  }


  /**
   * Length of Form Group used to know the count of sub-forms present
   */
  formLength() {
    const innerFormGroup = this.aiScreeningMasterForm.controls;
    return Object.keys(innerFormGroup);
  }


  /**
   * Use given static criteria
   * @param c criteia (question)
   */

  // useGivenCriteria(c: SCREENING_CRITERIA_SUGGESTION) {
  //   this.hideSuggestions = true;
  //   if (Object.keys(this.aiScreeningMasterForm.controls)?.length) {
  //     const formName = Object.keys(this.aiScreeningMasterForm.controls).pop();
  //     const FG = this.aiScreeningMasterForm.controls[`${formName}`] as FormGroup;
  //     FG.patchValue({ question: c.suggestion_content });
  //     c.selected = true;
  //     this.SUGGESTED_CRITERIA.sort(criteria => criteria.selected ? 1 : -1);
  //   }
  // }

  /**
   * Use given static criteria
   * @param c criteria (question)
   */
  useGivenCriteria(c: SCREENING_CRITERIA_SUGGESTION) {
    this.hideSuggestions = true;
    const formKeys = Object.keys(this.aiScreeningMasterForm.controls);
    if (formKeys.length) {
      const emptyKey = Object.keys(this.aiScreeningMasterForm.controls).pop();
      const firstFG = this.aiScreeningMasterForm.controls[emptyKey] as UntypedFormGroup;

      if (!firstFG.getRawValue()?.question?.trim()) {
        firstFG.patchValue({ question: c.suggestion_content });
      } else {
        this.addNewCriteria({
          criteria_content: c.suggestion_content,
          criteria_id: null
        });
      }
    } else {
      this.addNewCriteria({
        criteria_content: c.suggestion_content,
        criteria_id: null
      });
    }
    c.selected = true;
    this.SUGGESTED_CRITERIA.sort(criteria => criteria.selected ? 1 : -1);

      /**
     * Add Evaluation Criteria
     */
         const evaluationParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Criteria": c.suggestion_content

        }
        clevertap.event.push("Autopilot-Add AI Evaluation Criteria",evaluationParams);
  };

  /**
   * used to know either first form in empty or not
   * @returns
   */
  emptyFirstForm() {
    if (Object.keys(this.aiScreeningMasterForm.controls)?.length) {
      const formName = Object.keys(this.aiScreeningMasterForm.controls)[0];
      const FG = this.aiScreeningMasterForm.controls[`${formName}`] as UntypedFormGroup;
      if (FG && FG.getRawValue()?.question?.length) {
        return false;
      }
    }
    return true;
  }

  /**
   * used to know whether last form is empty or not
   */
  emptyLastForm() {
    if (Object.keys(this.aiScreeningMasterForm.controls)?.length) {
      const formName = Object.keys(this.aiScreeningMasterForm.controls).pop();
      const FG = this.aiScreeningMasterForm.controls[`${formName}`] as UntypedFormGroup;
      if (FG && FG.getRawValue()?.question?.length) {
        return false;
      }
    }
    return true;
  }

  ngOnDestroy() {
    this.formChangeSubscription?.unsubscribe();
  }

  /**
   * Method to redirect on blog page
   */
  learnMoreDetails() {
    window.open('https://fire-crib-a04.notion.site/Learn-how-to-use-AI-Sourcing-most-effectively-264d71872fa5806aa880c8ae3481d95f');
  };

    /**
   * Method to handle the dismissal of the project list component.
   */
  dismiss() {
    this.modelService.dismissAll();
    this.showExploreCandidateSpinner = false;
  }

  get tabClickAccess() {
    if(this.projectDetails.status === 'inactive') {
      return true;
    }
  }

   notifyAdmin() {
      this.changeButtonText = false;
      this.showNotifySpinner = true;
      const payload = {
        projectnumber: this.projectnumber
      }
      this.aiSourcingService.notifyAdmin(payload).subscribe((res:any)=>{
        this.showNotifySpinner = false;
        if(res.status == "success") {
          this.changeButtonText = true;
          this.successMessage = 'Notify admin successfully';
 setTimeout(() => {
            this.successMessage = '';
          }, 3000);
        } else {
          this.errorMessage = "Something went wrong";
           setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        }
      })
    }

}
